module.exports = __webpack_public_path__ + "static/media/figure-10a.91f5e68f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-10a.jpg
// module id = 1197
// module chunks = 0